export const getPersonPhotoUrl = (seed: string, size = 160) =>
  `https://i.pravatar.cc/${size}?u=${encodeURIComponent(seed)}`;

export const getInitials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
